import { render } from "./FloatingTool.vue?vue&type=template&id=2cf9a2d0&scoped=true&ts=true"
import script from "./FloatingTool.vue?vue&type=script&lang=ts"
export * from "./FloatingTool.vue?vue&type=script&lang=ts"

import "./FloatingTool.vue?vue&type=style&index=0&id=2cf9a2d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf9a2d0"]])

export default __exports__